import { Route } from '@angular/router';
import { BuildingTypeComponent } from './building-type/building-type.component';
import { AuthGuard, NoAuthGuard } from 'sting';
import { UnsavedChangesGuard } from './status-record/unsaved-changes.guard';
import { AppShellComponent } from './layout/app-shell/app-shell.component';



export const stingRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
        data: { title: 'Sting | STING' },
    },

    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'dashboard',
        data: { title: 'Sting | STING' },
    },
    {
        path: 'sign-in',
        loadChildren: () => import('./auth/sign-in/sign-in.routing').then(m => m.authSignInRoutes),
        data: { title: 'Přihlášení | STING' },
    },
    {
        path: 'summary',
        loadChildren: () => import('./property-intake/property-intake.routing').then(m => m.propertyIntakeRoutes),
        data: { title: 'Příjem nemovitosti | STING' },
    },
    {
        path: 'changepass',
        loadChildren: () => import('./auth/reset-password/reset-password.routing').then(m => m.authResetPasswordRoutes),
        data: { title: 'Sting | STING', layout: 'empty' },
    },
    {
        path: 'forgot-password',
        loadChildren: () => import('./auth/forgot-password/forgot-password.routing').then(m => m.authForgotPasswordRoutes),
        data: { title: 'Zapomenuté heslo | STING' },
    },
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'two-factor',
                loadChildren: () => import('./auth/two-factor-login/two-factor-login.routing').then(m => m.twoFactorLoginRouting),
                data: { title: 'Přihášení | STING' },
            },
        ],
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '500-internal-server-error',
                loadChildren: () => import('./error/error/error-500/error-500.routing').then(m => m.error500Routes),
                data: { title: 'Sting | STING' },
            },
            {
                path: '404-not-found',
                pathMatch: 'full',
                loadChildren: () => import('./error/error/error-404/error-404.routing').then(m => m.error404Routes),
                data: { title: '404 | STING' },
            },
            {
                path: '',
                component: AppShellComponent,
                children: [
                    {
                        path: 'building-type',
                        component: BuildingTypeComponent,
                        data: { title: 'Typ budovy | STING' },
                    },
                    {
                        path: 'dashboard',
                        loadChildren: () => import('./dashboard/dashboard.routing').then(m => m.stingDashBoardRoutes),
                        data: { title: 'Rozcestník | STING' },
                    },
                    {
                        path: 'status-record-form/:id',
                        loadComponent: () => import('./status-record/status-record-form/status-record-form.component').then(m => m.StatusRecordFormComponent),
                        data: { title: 'List dům | STING' },
                        canDeactivate: [UnsavedChangesGuard],
                    },
                    {
                        path: 'flat-form/:id',
                        loadComponent: () => import('./status-record/flat-form/flat-form.component').then(m => m.FlatFormComponent),
                        data: { title: 'List byt | STING' },
                        canDeactivate: [UnsavedChangesGuard],
                    },
                    {
                        path: 'area-form/:id',
                        loadComponent: () => import('./status-record/area-form/area-form.component').then(m => m.AreaFormComponent),
                        data: { title: 'List pozemek | STING' },
                        canDeactivate: [UnsavedChangesGuard],
                    },
                    {
                        path: 'others-form/:id',
                        loadComponent: () => import('./status-record/others-sale-form/others-sale-form.component').then(m => m.OthersSaleFormComponent),
                        data: { title: 'List ostatni | STING' },
                        canDeactivate: [UnsavedChangesGuard],
                    },
                    {
                        path: 'flat-rent-form/:id',
                        loadComponent: () => import('./status-record/flat-rent-form/flat-rent-form.component').then(m => m.FlatRentFormComponent),
                        data: { title: 'List pronájem byt | STING' },
                        canDeactivate: [UnsavedChangesGuard],
                    },
                    {
                        path: 'status-record-form',
                        loadComponent: () => import('./status-record/status-record-form/status-record-form.component').then(m => m.StatusRecordFormComponent),
                        data: { title: 'List dům | STING' },
                    },
                    {
                        path: 'flat-form',
                        loadComponent: () => import('./status-record/flat-form/flat-form.component').then(m => m.FlatFormComponent),
                        data: { title: 'List byt | STING' },
                    },
                    {
                        path: 'area-form',
                        loadComponent: () => import('./status-record/area-form/area-form.component').then(m => m.AreaFormComponent),
                        data: { title: 'List pozemek | STING' },
                    },
                    {
                        path: 'others-form',
                        loadComponent: () => import('./status-record/others-sale-form/others-sale-form.component').then(m => m.OthersSaleFormComponent),
                        data: { title: 'List ostatni | STING' },
                    },
                    {
                        path: 'flat-rent-form',
                        loadComponent: () => import('./status-record/flat-rent-form/flat-rent-form.component').then(m => m.FlatRentFormComponent),
                        data: { title: 'List pronájem byt | STING' },
                    },
                    {
                        path: 'forms',
                        loadChildren: () => import('./forms/forms.routing').then(m => m.stingFormsRoutes),
                        data: { title: 'List | STING' },
                    },
                    {
                        path: 'tours',
                        loadChildren: () => import('./tours/tours.routing').then(m => m.toursRouting),
                        data: { title: 'Potvrzení o prohlídce | STING' },
                    },
                    {
                        path: 'leads',
                        loadChildren: () => import('./leads/leads.routing').then(m => m.leadsRoutes),
                        data: { title: 'Příležitosti | STING' },
                    },
                    {
                        path: 'tasks',
                        loadComponent: () => import('./tasks/tasks.component').then(m => m.TasksComponent),
                        data: { title: 'Úkoly | STING' },
                    },
                    {
                        path: 'participants',
                        loadChildren: () => import('./participants/participants.routing').then(m => m.participantsRoutes),
                        data: { title: 'Klienti | STING' },
                    },
                    {
                        path: 'news',
                        loadChildren: () => import('./news/news.routing').then(m => m.newssRoutes),
                        data: { title: 'Novinky | STING' },
                    },
                    {
                        path: 'calculations',
                        loadChildren: () => import('./calculations/calculations.routing').then(m => m.calculationsRoutes),
                        data: { title: 'Kalkulačky | STING' },
                    },
                    {
                        path: 'courses',
                        loadChildren: () => import('./courses/courses.routing').then(m => m.coursesRoutes),
                        data: { title: 'Školení | STING' },
                    },
                    {
                        path: 'properties',
                        loadChildren: () => import('./properties/properties.routing').then(m => m.propertiesRoutes),
                        data: { title: 'Zakázky | STING' },
                    },
                ],
            },
        ],
    },
];
